/**
 * Traduções nossas — janelas (modais): criar conta, automações de categoria,
 * colunas da tabela, conexão com banco e importação.
 *
 * A chave é a frase em inglês, byte a byte como está em `locale/en.json`.
 */
export const modais: Record<string, string> = {
  // --- Automações de categoria ---
  'Select an automation on the left.': 'Escolha uma automação à esquerda.',
  'Select automation': 'Escolher automação',
  Priority: 'Prioridade',
  'Priority: {{priority}}': 'Prioridade: {{priority}}',
  Note: 'Observação',
  'Imported from notes-based templates. Review and Save to complete the migration.':
    'Importado dos modelos escritos em observações. Revise e salve pra concluir a migração.',
  'Show original templates': 'Ver os modelos originais',
  'The projection shows the most that these automations could budget on their own. The actual amount may be smaller when To Budget is empty or when higher-priority categories run first.':
    'A projeção mostra o máximo que estas automações conseguiriam aportar sozinhas. O valor real pode ser menor quando não há saldo em "A orçar" ou quando categorias de prioridade maior rodam antes.',
  'Add balance cap': 'Adicionar teto de saldo',
  'Add long-term goal': 'Adicionar meta de longo prazo',
  'Add end of month cleanup': 'Adicionar limpeza de fim de mês',
  'Remove cleanup': 'Remover a limpeza',
  'Un-migrate to text notes': 'Voltar para modelos em texto',
  'Select cleanup': 'Escolher a limpeza',
  'No automations yet': 'Nenhuma automação ainda',
  'Only one of this type allowed per category':
    'Só é permitida uma deste tipo por categoria',
  'This category isn&rsquo;t supported in the UI yet':
    'Esta categoria ainda não é editável por aqui',
  'Overwrite with budget templates': 'Substituir pelos modelos de orçamento',
  'Export from automations UI:': 'Exportar das automações:',

  // --- Nova conta ---
  'e.g. Bank, Savings, Credit Card, Cash':
    'ex.: Conta corrente, Poupança, Cartão de crédito, Dinheiro',
  'Off-budget accounts (like investments, loans, or your house) are tracked but not part of your spending budget.':
    'Contas fora do orçamento (investimentos, empréstimos, imóveis) são acompanhadas, mas não entram no seu planejamento de gastos.',

  // --- Lançamentos ---
  'Create schedule anyway': 'Criar o agendamento mesmo assim',
  'Turn the new transaction into a schedule':
    'Transformar o novo lançamento em agendamento',
  'Make a transfer from the two selected transactions':
    'Transformar os dois lançamentos escolhidos numa transferência',
  'Automatically rename these payees in the future':
    'Renomear estes favorecidos automaticamente daqui pra frente',
  'For this budget only': 'Só neste arquivo',

  // --- Colunas da tabela ---
  'Reorder {{ columnName }} column': 'Reordenar a coluna {{ columnName }}',
  'Always shown': 'Sempre visível',
  'Table columns': 'Colunas da tabela',
  'Transaction table columns': 'Colunas da tabela de lançamentos',
  'Use this layout everywhere, not just in the current view.':
    'Usar este arranjo em todas as telas, não só nesta.',

  // --- Conexão com banco ---
  'It is required to provide a User Token and an App Token.':
    'É preciso informar o token do usuário e o token do aplicativo.',
  'Set-up Akahu': 'Configurar o Akahu',
  'User Access Token:': 'Token de acesso do usuário:',
  'Usage type:': 'Tipo de uso:',
  personal: 'pessoal',
  'Waiting on Enable Banking...': 'Aguardando o Enable Banking…',
  'To link your bank account, you will be redirected to a new page where Enable Banking will ask to connect to your bank. Enable Banking will not be able to withdraw funds from your accounts.':
    'Pra conectar sua conta, você vai para uma página onde o Enable Banking pede acesso ao seu banco. Ele não consegue movimentar dinheiro das suas contas.',
  'Enable Banking integration has not yet been configured.':
    'A integração com o Enable Banking ainda não foi configurada.',
  'Configure Enable Banking integration':
    'Configurar a integração com o Enable Banking',
  'It is required to provide both the Application ID and the secret key.':
    'É preciso informar o ID do aplicativo e a chave secreta.',
  'Failed to read the key file. Please try again.':
    'Não foi possível ler o arquivo da chave. Tente de novo.',
  'Set up Enable Banking': 'Configurar o Enable Banking',
  'Secret Key (.pem file):': 'Chave secreta (arquivo .pem):',
  'When setting up your application, use the following as the redirect URL:':
    'Ao configurar seu aplicativo, use esta URL de redirecionamento:',
  'Enable Banking requires HTTPS for the redirect URL. Your current connection is not secure.':
    'O Enable Banking exige HTTPS na URL de redirecionamento. Sua conexão atual não é segura.',

  // --- Importação ---
  'This file is too large to import, sorry! Visit https://actualbudget.org/contact/ for support.':
    'Este arquivo é grande demais pra importar. Veja https://actualbudget.org/contact/ pra suporte.',
};
